import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ItemGeneralListado } from '../../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';
import { GrowlType, AlertService } from 'app/infrastructure/services/alert.service';
import { LoaderService } from 'app/infrastructure/services/loader.service';
import { Translator } from 'angular-translator';
import { OutputService } from '../../../infrastructure/services/output.service';
import { OutputModel } from 'app/infrastructure/model/classes/output.classes';

@Component({
    selector: 'sx-detail-output',
    templateUrl: './detail.output.component.html',
})
export class DetailOutputComponent implements OnInit {
    output: OutputModel;
    codSistema: string;
    codOutput: string;
    seccionActual: string;
    esNuevo = true;
    checkeandCodigo = false;
    errorCodigo = null;
    completitud = 0;

    constructor(public loaderService: LoaderService,
        private alertService: AlertService,
        private outputService: OutputService,
        private router: Router,
        private aRoute: ActivatedRoute,
        private translator: Translator) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.codSistema = params['codsistema'];
            this.codOutput = params['codoutput'];

            this.esNuevo = false;

            if (this.codOutput === 'nuevo') {
                this.esNuevo = true;
                this.output = {
                    outputCode: '',
                    systemCode: this.codSistema,
                    description: <string>this.translator.instant('OUTPUT_DESCRIPCION'),
                    status: 'A',
                    lastFriday: false,
                    recurrencyFortnight: false,
                    recurrencyMonthDay: false,
                    delayTask: false,
                    repeatTaskEver: false,
                    expireTask: false
                };
                return;
            }
            this.outputService
                .get(this.codSistema, this.codOutput)
                .subscribe(data => {
                    if (!data) {
                        return this.router.navigateByUrl('/soc/404');
                    }
                    this.output = data;
                    this.inicializarCampos(data);
                });
        });
    }

    validarCodigo() {
        this.errorCodigo = null;

        if (!this.output.outputCode || this.output.outputCode.length <= 0) {
            this.errorCodigo = 'El código debe tener al menos 1 caracter.';
            return false;
        }

        if (this.output.outputCode.length > 3) {
            this.errorCodigo = 'El código debe tener como máximo 3 caracteres.';
            return false;
        }

        if (this.output.outputCode === 'nuevo') {
            this.errorCodigo = 'Código de Output inválido.';
            return false;
        }

        return true;
    }

    createOutput() {
        if (!this.validarCodigo()) {
            return;
        }

        this.checkeandCodigo = true;

        // We validate if the output code is not being used
        this.outputService.get(this.codSistema, this.output.outputCode)
            .subscribe(res => {
                this.checkeandCodigo = false;
                // If the code already exists, I can not create an output
                if (res !== null) {
                    this.errorCodigo = <string>this.translator.instant('CODE_EXISTS');
                    return false;
                }

                // I create the output
                this.outputService
                    .create(this.output)
                    .then(output => {
                        this.alertService.showGrowl({
                            type: GrowlType.SUCCESS,
                            body: 'OUTPUT_CREADO_CORRECTAMENTE',
                        });

                        this.router.navigate(['../', output.outputCode], { relativeTo: this.aRoute.parent });
                    });
            });
    }

    editarDescripcion(nuevoTexto) {
        this.output.description = nuevoTexto;
        this.editOutput();
    }

    editarDescripcionExt(nuevoTexto) {
        this.output.descriptionExt = nuevoTexto;
        this.editOutput();
    }

    /**
     * Actualiza la Imagen del sistema en el backend
     */
    editarImagen(nuevaImagen) {
        this.output.image = nuevaImagen.imagenBase64;
        this.editOutput();
    }

    private editOutput() {
        this.outputService.edit(this.output.outputCode, this.output.systemCode, this.output)
            .then(data => {
                this.inicializarCampos(data);
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'EDITADO_CORRECTAMENTE',
                });
            });
    }

    private inicializarCampos(data) {
        if (data) {
            this.completitud = data.completeness ? JSON.parse(data.completeness).percentage : 0;
            this.output.fechaActualizacion = data.fechaActualizacion;
            this.output.modificado = data.modificado;
            this.output.urlImage = data.urlImage;
        }
    };
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/detail/detail.output.component.ts